import { FC, ReactNode } from "react";

import HeadLayout from "../Head/HeadLayout";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";

import { PagesProps } from "@/props/PagesProps";

import styles from "./layout.module.css";

interface PagesWrapperProps extends PagesProps {
    children?: ReactNode;
}

export const Layout: FC<PagesWrapperProps> = ({ title, description, transition, children }) => {
    return (
        <div className={styles.layoutContainer}>
            <HeadLayout
                title={title}
                description={description} />

            {
                transition &&
                <video className={styles.videoSourceBackground} autoPlay muted loop playsInline>
                    <source src={transition} type="video/mp4" />
                </video>
            }

            <NavBar />

            {children}

            <Footer />
        </div>
    );
};